import type { ReactNode } from "react";
import type { User } from "@common/types/user";
import type { WorkspaceMember } from "@common/types/workspace";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { Picker } from "@design-system/Picker/Picker.lib";

interface TaskAssigneeCellPickerProps {
    value: User["id"] | null;
    members: readonly WorkspaceMember[];
    onValueChange: (userId: User["id"] | null) => void;
    /** A Picker trigger part (e.g. `Picker.CellContent`). */
    trigger: ReactNode;
}

/** The assignee picker List's Assignee column opens: Unassigned, then the workspace's members. */
export const TaskAssigneeCellPicker = ({
    value,
    members,
    onValueChange,
    trigger,
}: Readonly<TaskAssigneeCellPickerProps>) => (
    <Picker.Select value={value} onValueChange={(id) => onValueChange(id)}>
        {trigger}
        <Picker.Popup>
            <Picker.List>
                <Picker.Item onSelect={() => onValueChange(null)}>
                    Unassigned
                </Picker.Item>
                {members.map((member) => (
                    <Picker.Item
                        key={member.user.id}
                        value={member.user.id}
                        leading={
                            <UserAvatar
                                user={member.user}
                                size="xs"
                                aria-hidden
                            />
                        }
                    >
                        {member.user.name}
                    </Picker.Item>
                ))}
            </Picker.List>
        </Picker.Popup>
    </Picker.Select>
);
